<template>
  <nav class="fixed-top navbar navbar-dark navbar-expand-lg" v-bind:class="{ 'ScrollIsTop': isTop }">
    <img src="../assets/skearLogo2020-sm-min.png" alt="skear" class="skearLogo">
    <a class="navbar-brand mr-auto" href="#page_top" v-smooth-scroll>SKEAR</a>
    <button
      class="navbar-toggler navbar-toggler-right collapsed"
      type="button"
      data-toggle="collapse"
      data-target="#navb"
      aria-expanded="false"
    >
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="navbar-collapse collapse" id="navb" style>
      <ul class="navbar-nav ml-auto">
        <li class="nav-item">
          <a class="nav-link" href="#about" v-smooth-scroll>{{ $t('about_menu') }}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#games" v-smooth-scroll>{{ $t('games_menu') }}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="https://drive.google.com/drive/folders/1-QAk1-y9qCHxB7rGMD7O-ee6II3KQe_4?usp=sharing" target="_blank">{{ $t('press_menu') }}</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#contact" v-smooth-scroll>{{ $t('contact_menu') }}</a>
        </li>
        <li class="nav-item">
          <div class="language">
            <a v-bind:class="{ 'langActiv': isLangEnActive }" class="nav-link" href="#!" @click="setLocale('en')">EN</a> 
            <span class="separetion">|</span> 
            <a v-bind:class="{ 'langActiv': isLangFrActive }" class="nav-link" href="#!" @click="setLocale('fr')">FR</a>
          </div>
        </li>
      </ul>
    </div>

    <div class="reseaux_sociaux">
      <a class="icon" href="https://www.facebook.com/SkearGames" target="_blank">
        <span>
          <i class="fab fa-facebook-square"></i>
        </span>
      </a>
      <a class="icon" href="https://twitter.com/SkearGames" target="_blank">
        <span>
          <i class="fab fa-twitter-square"></i>
        </span>
      </a>
      <a class="icon" href="https://www.instagram.com/skear.games" target="_blank">
        <span>
          <i class="fab fa-instagram"></i>
        </span>
      </a>
      <a class="icon" href="https://www.youtube.com/channel/UCNzqX19JDStQ04GIJ6e8tbA " target="_blank">
        <span>
          <i class="fab fa-youtube-square"></i>
        </span>
      </a>
    </div>
  </nav>
</template>

<script>
export default {
  name: "Navbar",
  data() {
    return {
      isTop: true,
      isLangEnActive: true,
      isLangFrActive: false
    };
  },
  methods: {
    handleScroll: function() {
      if (window.scrollY == 0) 
        this.AddScrollTopCss();
      else 
        this.RemoveScrollTopCss();
    },
    AddScrollTopCss: function() {
      this.isTop = true;
    },
    RemoveScrollTopCss: function() {
      this.isTop = false;
    },
    setLocale(locale){
      this.$i18n.locale = locale;

      if(locale == 'en'){
        this.isLangEnActive = true;
        this.isLangFrActive = false;
      }

      if(locale == 'fr'){
        this.isLangEnActive = false;
        this.isLangFrActive = true;
      }
        
    }
  },
  created: function() {
    window.addEventListener("scroll", this.handleScroll);

    var userLang = navigator.language || navigator.userLanguage; 
    if(userLang == "fr-FR")
      this.setLocale('fr');
    else
      this.setLocale('en');
  },
  destroyed: function() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.navbar{
  transition: 0.25s;
}
.navbar:not(.ScrollIsTop){
  backdrop-filter: blur(2px);
  background-color: rgba(0, 0, 0, .9);
}
.navbar-brand, .nav-link {
  font-family: 'Montserrat', sans-serif;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.7);
  transition: 0.3s;
  font-size: 1.5rem;
  &:hover {
    color: white;
  }
}
.navbar-brand{
  font-weight: 700;
}
.skearLogo {
  width: 38px;
  float: left;
  margin-right: 9px;
}
.navbar-toggler{
  border:none;
}
.nav-link {
  color: rgba(255, 255, 255, 0.7);
  text-transform: uppercase;
  font-weight: 700;
  font-size: 16px;
  padding-right: .5rem;
  padding-left: .5rem;
  &:hover {
    color: white;
  }
}
.language{
  display: block;
  .langActiv{
    color: white;
  }
  .nav-link{
    display: inline-block;
    &:nth-child(2){
      padding: 0;
    }
  }
  .separetion{
    color: white;
    font-size: 13px;
  }
}
.reseaux_sociaux{
  position: absolute;
  right: 0;
  top: 30vh;
  display: flex;
  flex-direction: column;
  .icon {
    margin: 0 10px;
    span{
      font-size: 2.3em;
      color: white;
      opacity: 0.25;
      &:hover{
        color: #62bedb;
        opacity: 1;
      }
    }
  }
}
@media (max-width: 720px) { 
  .reseaux_sociaux{
    display: none;
  }
}
</style>
